const createEmptyCssRule = (stylesheet, selector) => {
  const { cssRules } = stylesheet;
  const cssText = `${selector} {}`;
  stylesheet.insertRule(cssText, cssRules.length);
  return cssRules[cssRules.length - 1];
};

export default createEmptyCssRule;
